import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import React from "react";

export const recordingFAQs = [
  {
    id: 1,
    heading: "Recordings sharing",
    alwaysShow: true,
    questions: [
      {
        id: 11,
        title: "Will my sessions be recorded?",
        description:
          "Yes! Exly Zoom records all sessions automatically by default. However, if you turn off the recording during your session, no recording will be saved.",
        icon: getS3AssetCDNUrl(
          "assets/images/ct_upfront/recording_faq_icon_1.svg"
        ),
      },
      {
        id: 12,
        title: "Can I share my session recordings with customers?",
        description: (
          <div>
            Yes! Simply turn on the &apos;
            <strong>Share recordings with customers</strong>&apos; toggle above.
            Exly will then automatically create a course packaging all your
            recordings in it and share the course with your customers.
          </div>
        ),
        icon: getS3AssetCDNUrl(
          "assets/images/ct_upfront/recording_faq_icon_2.svg"
        ),
      },
      {
        id: 13,
        title:
          "Where can I find my session recordings if I chose to share them?",
        description: (
          <div>
            When you enable &apos;
            <strong>Share recordings with customers</strong>&apos;, Exly
            automatically creates a course that collects all recordings. This
            course:
            <br />
            - Looks similar to your main offering
            <br />
            - Has the same title with a &lsquo;Recording -&rsquo; prefix, and
            the same cover image as the main offering for easy identification.
            <br />- Can be found under &lsquo;<strong>Live Offerings</strong>
            &rsquo;.
            <br />
            - Is hidden from your website by default but accessible to session
            attendees and auto-added to their dashboard for free.
            <br />
            <br />
            <strong className="tw-text-black">For example:</strong>
            <ExlyImage
              className="tw-w-full tw-mt-4"
              path="assets/images/common/recording_faq_section_1.svg"
              alt="FAQ"
            />
          </div>
        ),
        icon: getS3AssetCDNUrl(
          "assets/images/ct_upfront/recording_faq_icon_3.svg"
        ),
      },
    ],
  },
  {
    id: 2,
    heading: "Missing recordings",
    alwaysShow: false,
    questions: [
      {
        id: 21,
        title: "Why might some recordings be missing?",
        description: (
          <div>
            If a recording is missing, it could be due to:
            <br />
            - The recording was manually turned off during the session.
            <br />
            - A technical issue with Zoom&apos;s recording service.
            <br />
            - The session ended unexpectedly before the recording could be
            saved.
            <br />
            Check your email for available recordings or visit the
            &apos;Unmapped Recordings&apos; section in your course.
          </div>
        ),
        icon: getS3AssetCDNUrl(
          "assets/images/ct_upfront/recording_faq_icon_4.svg"
        ),
      },
      {
        id: 22,
        title: "How can I find recordings that are missing?",
        description: (
          <div>
            If a recording wasn&apos;t automatically linked to a session, you
            can find it in the &lsquo;Unmapped Recordings&rsquo; section:
            <br />
            1. Open the Recordings Course.
            <br />
            2. Click the three-dot menu.
            <br />
            3. Select &lsquo;Manage Offering&rsquo;.
            <br />
            4. Navigate to &lsquo;Unmapped Recordings&rsquo;.
            <br />
            Here, you will find any recordings that were not automatically
            assigned to a session. Once you assign it to a session, it will
            automatically get added to the course and be shared with all the
            customers who it is meant for.
          </div>
        ),
        icon: getS3AssetCDNUrl(
          "assets/images/ct_upfront/recording_faq_icon_5.svg"
        ),
      },
    ],
  },
];

export const defaultExpandedFaqID = 11;
